import './frameImage.scss';
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { svcMedium } from '../../components/image-router';
import { useTranslation } from 'react-i18next';

const FrameImage = ({ image, section }) => {
    const { t } = useTranslation();

    return (
        <>
            {(section === 'home') && (
                <div>
                    <div className='custom-container'>
                        <img className="imgbox" src={image} alt="Image" />
                        <div className='topCenter d-none d-lg-block'>
                            <div className='styleTitle mt-5'>
                                {t('home.heroTitle')}
                            </div>
                            <div>
                                <p className='styleTitle2'>{t('home.heroSubtitle')}</p>
                            </div>
                        </div>
                        <div className='svcLogo d-none d-lg-block styleText px-2 py-4 text-center align-middle'>
                            <div className='my-2'>
                                {t('home.servingWith')} <br /> {t('home.svcFoundation')}
                            </div>
                        </div>
                    </div>
                    <div className='d-lg-none textMobile styleText text-center py-md-4 py-lg-4'>
                        {t('home.servingWith')} <br /> {t('home.svcFoundation')}
                    </div>
                </div>
            )}

            {(section != 'home') && (
                <div>
                    <img class="imgbox" src={image} alt="Image" />
                </div>
            )}
        </>


    );
}

export default FrameImage;
